module.exports = __webpack_public_path__ + "img/mario.7fb918e9.png";